import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { cn } from "@/lib/utils";
import { formatBytes } from "@/utils/file";
import { ContentTypeEnums } from "../constants/lib.constants";
import { IContent, MySharedContentDef } from "../types/lib.types";
import FileIcon from "./FileIcon";

interface ILibraryTableProps {
  contents?: IContent[];
  contentsShared?: MySharedContentDef[];
  contentSelected?: IContent;
  setContentSelected: (content: IContent) => void;
}

const LibraryTable = ({
  contents,
  contentsShared,
  contentSelected,
  setContentSelected,
}: ILibraryTableProps) => {
  return (
    <Table classNameWrapper="overflow-visible">
      <TableHeader>
        <TableRow
          className={cn(
            "bg-white border-b hover:bg-white",
            "[&>th]:sticky [&>th]:top-[68px] [&>th]:bg-white [&>th]:z-10",
            "[&>th]:before:absolute [&>th]:before:left-0 [&>th]:before:bottom-0 [&>th]:before:w-full [&>th]:before:border-b"
          )}
        >
          <TableHead className="text-xs">
            <div className="">Tên tệp tin</div>
          </TableHead>
          <TableHead className="w-[150px] text-xs p-0">
            <div className="border-l-[1px] border-tg-border-default pl-4">
              Kích thước
            </div>
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {contents &&
          contents.map((content) => {
            return (
              <TableRow
                key={content.id}
                className={cn(
                  "hover:bg-gray-50 cursor-pointer",
                  contentSelected?.id === content.id ? "bg-secondary-100" : ""
                )}
                onClick={() => {
                  setContentSelected(content);
                }}
              >
                <TableCell>
                  <div className="space-x-2 flex items-center">
                    <div>
                      <FileIcon extension={content.extension} />
                    </div>
                    <div
                      className={cn("font-medium line-clamp-1")}
                      title={content.name}
                    >
                      {content.name}
                    </div>
                  </div>
                </TableCell>
                <TableCell>{formatBytes(content.size)}</TableCell>
              </TableRow>
            );
          })}
        {contentsShared &&
          contentsShared.map((contentShared) => {
            const content = contentShared.content;
            return (
              <TableRow
                key={content.id}
                className={cn(
                  "hover:bg-gray-50 cursor-pointer",
                  contentSelected?.id === content.id ? "bg-secondary-100" : ""
                )}
                onClick={() => {
                  setContentSelected(content);
                }}
              >
                <TableCell>
                  <div className="space-x-2 flex items-center ">
                    <div>
                      <FileIcon extension={content.extension} />
                    </div>
                    <div
                      className={cn(
                        "font-medium line-clamp-1",
                        content.type === ContentTypeEnums.FOLDER
                          ? "cursor-pointer underline-offset-4 hover:underline"
                          : ""
                      )}
                      title={content.name}
                    >
                      {content.name}
                    </div>
                  </div>
                </TableCell>
                <TableCell>{formatBytes(content.size)}</TableCell>
              </TableRow>
            );
          })}
      </TableBody>
    </Table>
  );
};

export default LibraryTable;
